import React, { useEffect } from 'react';
import { useAuth } from '../context/AuthContext';
import { Header } from '../components/Layout/Header';
import { Footer } from '../components/Layout/Footer';

export const TermsPage: React.FC = () => {
    const { user, loading } = useAuth();

    useEffect(() => {
        window.scrollTo(0, 0);
    }, []);

    if (loading) {
        return (
            <div className="min-h-screen flex items-center justify-center bg-slate-50">
                <div className="text-center">
                    <div className="inline-block animate-spin rounded-full h-12 w-12 border-2 border-slate-200 border-t-blue-600 mb-4"></div>
                </div>
            </div>
        );
    }

    return (
        <div className="bg-white min-h-screen flex flex-col h-screen overflow-y-auto">
            <Header
                activeAudience="recruiter"
                showLandingNav={!user}
            />

            <main className="flex-1 w-full max-w-4xl mx-auto px-4 md:px-6 py-24 md:py-32">
                <div className="prose prose-slate lg:prose-lg max-w-none">
                    <h1 className="text-3xl md:text-4xl font-bold text-slate-900 mb-2">Terms & Conditions</h1>
                    <p className="text-slate-500 mb-8">Last Updated: 08/11/2025</p>

                    <p className="text-slate-600 mb-6">
                        These Terms & Conditions ('Terms') outline the agreement between you ('the user', 'you') and the JobVital team ('JobVital', 'we', 'our', 'us') regarding your use of the JobVital platform. By using our platform or clicking 'Submit', you agree to these Terms.
                    </p>

                    <section className="mb-8">
                        <h2 className="text-xl md:text-2xl font-bold text-slate-800 mb-4">1. Use of the Platform</h2>
                        <p className="text-slate-600">
                            JobVital allows you to discover and apply to job opportunities. Some jobs are posted directly by JobVital on behalf of third-party companies ('Clients'). You agree to provide accurate and truthful information when creating an account or submitting an application. You must be at least 18 years old.
                        </p>
                    </section>

                    <section className="mb-8">
                        <h2 className="text-xl md:text-2xl font-bold text-slate-800 mb-4">2. Job Applications</h2>
                        <p className="text-slate-600">
                            Applying through JobVital does not guarantee an interview or employment. JobVital may share your CV and details with employers when we consider you a good match. If not, we may continue to send you other suitable job opportunities. JobVital is not responsible for hiring outcomes or communication delays from employers.
                        </p>
                    </section>

                    <section className="mb-8">
                        <h2 className="text-xl md:text-2xl font-bold text-slate-800 mb-4">3. Data & Privacy</h2>
                        <p className="text-slate-600">
                            By using our platform, you consent to the collection and processing of your data in accordance with our Privacy Policy. You can delete your account at any time to permanently remove your data.
                        </p>
                    </section>

                    <section className="mb-8">
                        <h2 className="text-xl md:text-2xl font-bold text-slate-800 mb-4">4. Intellectual Property</h2>
                        <p className="text-slate-600">
                            All content, branding, and materials on the JobVital platform belong to JobVital. You may not copy, reproduce, or distribute them without permission.
                        </p>
                    </section>

                    <section className="mb-8">
                        <h2 className="text-xl md:text-2xl font-bold text-slate-800 mb-4">5. Liability Disclaimer</h2>
                        <p className="text-slate-600">
                            JobVital is an intermediary that connects candidates with employers. We make no guarantees about job availability, suitability, or hiring outcomes. We are not liable for any loss, damage, or inconvenience arising from the use of our platform or from decisions made by hiring companies.
                        </p>
                    </section>

                    <section className="mb-8">
                        <h2 className="text-xl md:text-2xl font-bold text-slate-800 mb-4">6. Account Termination</h2>
                        <p className="text-slate-600">
                            We reserve the right to suspend or remove any account that violates these Terms or misuses the platform.
                        </p>
                    </section>

                    <section className="mb-8">
                        <h2 className="text-xl md:text-2xl font-bold text-slate-800 mb-4">7. Updates</h2>
                        <p className="text-slate-600">
                            We may update these Terms from time to time. Continued use of the platform after changes means you accept the updated version.
                        </p>
                    </section>

                    <section className="mb-8">
                        <h2 className="text-xl md:text-2xl font-bold text-slate-800 mb-4">8. Contact</h2>
                        <p className="text-slate-600">
                            For questions about these Terms, contact: <a href="mailto:info@jobvital.co.uk" className="text-blue-600 hover:text-blue-800">info@jobvital.co.uk</a>
                        </p>
                    </section>
                </div>
            </main>

            <Footer />
        </div>
    );
};
